export default __webpack_public_path__ + "static/media/Hisoka.792cb042.gif";